import { PropsWithChildren } from "react";
import { useInterfaceState } from "../../InterfaceContext";

export const Entrance = ({ children }: PropsWithChildren<{}>) => {
  const { interfaceState } = useInterfaceState();

  return interfaceState.currentEntrance ? <>{children}</> : null;
};
